// We need to import the CSS so that webpack will load it.
// The MiniCssExtractPlugin is used to separate it out into
// its own CSS file.
import "../css/app.scss"

// webpack automatically bundles all modules in your
// entry points. Those entry points can be configured
// in "webpack.config.js".
//
// Import deps with the dep name or local files with a relative path, for example:
//
//     import {Socket} from "phoenix"
//     import socket from "./socket"
//
import "phoenix_html"
import {Socket} from "phoenix"
import {LiveSocket} from "phoenix_live_view"

// General components
import {Hooks as CurrencyInputHooks} from './components/currency_input'
import {Hooks as DownloadHooks} from './components/download'
import {Hooks as JSONTextAreaHooks} from './components/json_text_area'
import {Hooks as SelectListHooks} from './components/select-list'
import {Hooks as TagHooks} from './components/tags'
import {Hooks as TelInputHooks} from './components/tel_input'
import {Hooks as ChartHooks} from './components/chart'
import * as sharedHooks from '@solar-assistant/shared-ui/js/hooks/index.js'

// Page components
import {Hooks as ChangelogHooks} from './pages/changelog'
import {Hooks as OfflineHooks} from './pages/offline'
import {Hooks as ShopHooks} from './pages/shop'
import {Hooks as SiteHooks} from './pages/sites'
import {Hooks as HelpHooks} from './pages/help'
import {Hooks as UserHooks} from './pages/users'

let Hooks = {}
Object.assign(Hooks, CurrencyInputHooks);
Object.assign(Hooks, DownloadHooks);
Object.assign(Hooks, JSONTextAreaHooks);
Object.assign(Hooks, sharedHooks);
Object.assign(Hooks, SelectListHooks);
Object.assign(Hooks, TagHooks);
Object.assign(Hooks, TelInputHooks);
Object.assign(Hooks, ChartHooks);

Object.assign(Hooks, ChangelogHooks);
Object.assign(Hooks, OfflineHooks);
Object.assign(Hooks, ShopHooks);
Object.assign(Hooks, SiteHooks);
Object.assign(Hooks, HelpHooks);
Object.assign(Hooks, UserHooks);

let csrfToken = document.querySelector("meta[name='csrf-token']").getAttribute("content")
let liveSocket = new LiveSocket("/live", Socket, {params: {_csrf_token: csrfToken}, hooks: Hooks})

// connect if there are any LiveViews on the page
liveSocket.connect()

// expose liveSocket on window for web console debug logs and latency simulation:
// >> liveSocket.enableDebug()
// >> liveSocket.enableLatencySim(1000)
window.liveSocket = liveSocket

import './layout.js'
import './google_analytics.js'
import './charts.js'

// Special elements
import './elements/password_input.js'
import './elements/time.js'
import '@solar-assistant/shared-ui/js/elements/tooltips.js'
